import React, { useState } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { 
  Layout, 
  Menu, 
  theme, 
  Avatar, 
  Space, 
  Typography, 
  Button,
  Badge,
  Dropdown
} from 'antd';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  ShoppingOutlined,
  AppstoreOutlined,
  TableOutlined,
  ShoppingCartOutlined,
  LogoutOutlined,
  UserOutlined,
  ScheduleOutlined,
  DownOutlined 
} from '@ant-design/icons';
import { FaUtensils, FaUniversity, FaBuilding, FaChartLine } from 'react-icons/fa';
import Api from '../api/Api';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const Home = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState(['1']);
  const [openKeys, setOpenKeys] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [nome, setNome] = useState('');
  const [pedidos, setPedidos] = useState(0);
  const [perfil, setPerfil] = useState('');

  // Obter perfil do token
  useEffect(() => {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      if (token && token.perfil) {
        setPerfil(token.perfil);
      }
    } catch (error) {
      console.error('Erro ao obter perfil:', error);
    }
  }, []);

  // Verificação de tempo de sessão
  useEffect(() => {
    const loginTime = parseInt(localStorage.getItem("loginTime"), 10) || Date.now();
    localStorage.setItem("loginTime", loginTime);

    const now = Date.now();
    const expired = now - loginTime > 3600000; // 1 hora

    if (expired) {
      logout();
      return;
    }

    const remainingTime = 3600000 - (now - loginTime);
    const timeout = setTimeout(logout, remainingTime);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    fetchData(); // chama imediatamente ao montar

    const interval = setInterval(() => {
      fetchData();  
    }, 6000);  

    return () => clearInterval(interval);
  }, []);

  const fetchData = async () => {
    try {
      const dados = await Api.ListUserId();
      const _pedidos = await Api.CountPedidos();
      setPedidos(_pedidos.id);
      setNome(dados.nome);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  useEffect(() => {
    let newSelectedKey = ['1'];
    
    if (location.pathname.includes('/produtos')) {
      newSelectedKey = ['2'];
    } else if (location.pathname.includes('/categorias')) {
      newSelectedKey = ['3'];
    } else if (location.pathname.includes('/mesas')) {
      newSelectedKey = ['4'];
    } else if (location.pathname.includes('/pedidos')) {
      newSelectedKey = ['5'];
    } else if (location.pathname.includes('/usuarios')) {
      newSelectedKey = ['6'];
    } else if (location.pathname.includes('/estoque')) {
      newSelectedKey = ['7-1'];
    } else if (location.pathname.includes('/baixa')) {
      newSelectedKey = ['7-2'];
    } else if (location.pathname.includes('/inventario')) {
      newSelectedKey = ['7-3'];
    } else if (location.pathname.includes('/contas')) {
      newSelectedKey = ['8'];
    } else if (location.pathname.includes('/empresa')) {
      newSelectedKey = ['9'];
    } 
     else if (location.pathname.includes('/relatorio_produtos_vendidos')) {
      newSelectedKey = ['10-1'];
    }
     else if (location.pathname.includes('/documentos')) {
      newSelectedKey = ['10-2'];
    }
   else if (location.pathname.includes('/pedidos_cancelados')) {
      newSelectedKey = ['10-3'];
    }
    
    setSelectedKey(newSelectedKey);
    
    if (location.pathname.includes('/estoque') || 
        location.pathname.includes('/baixa') || 
        location.pathname.includes('/inventario')) {
      setOpenKeys(['7']);
    } 
    else if (location.pathname.includes('/relatorio_produtos_vendidos') || 
        location.pathname.includes('/documentos') || 
        location.pathname.includes('/pedidos_cancelados')) {
      setOpenKeys(['10']);
    } 
    else {
 
      setOpenKeys([]);
    }
  }, [location.pathname]);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("loginTime");
    window.location.href = "/";
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const userMenuItems = [
    {
      key: '1',
      icon: <LogoutOutlined />,
      label: 'Sair',
      danger: true,
      onClick: logout
    },
  ];

  // Submenu de Estoque
  const estoqueSubMenu = {
    key: '7',
    icon: <ScheduleOutlined />,
    label: 'Estoque',
    profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE'],
    children: [
      {
        key: '7-1',
        label: 'Entrada em estoque',
        onClick: () => {
          navigate('/estoque');
          setOpenKeys(['7']); // Manter aberto ao clicar em um item do submenu
        },
        profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
      },
      {
        key: '7-2',
        label: 'Baixa',
        onClick: () => {
          navigate('/baixa');
          setOpenKeys(['7']); // Manter aberto ao clicar em um item do submenu
        },
        profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
      },
      {
        key: '7-3',
        label: 'Inventário',
        onClick: () => {
          navigate('/inventario');
          setOpenKeys(['7']); // Manter aberto ao clicar em um item do submenu
        },
        profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
      }
    ]
  };

  const relatorioSubMenu = {
    key: '10',
    icon: <FaChartLine />,
    label: 'Relatórios',
    profiles: ['ADMINISTRADOR'],
    children: [
      {
        key: '10-1',
        label: 'Produtos vendidos',
        onClick: () => {
          navigate('/relatorio_produtos_vendidos');
          setOpenKeys(['10']); // Manter aberto ao clicar em um item do submenu
        },
         profiles: ['ADMINISTRADOR'],
      },
       {
        key: '10-2',
        label: 'Documentos',
        onClick: () => {
          navigate('/documentos');
          setOpenKeys(['10']); // Manter aberto ao clicar em um item do submenu
        },
         profiles: ['ADMINISTRADOR'],
      },
      {
        key: '10-3',
        label: 'Pedidos cancelados',
        onClick: () => {
          navigate('/pedidos_cancelados');
          setOpenKeys(['10']); // Manter aberto ao clicar em um item do submenu
        },
         profiles: ['ADMINISTRADOR'],
      },
      
    ]
  };



  // Menu completo
  const allMenuItems = [
    {
      key: '1',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => {
        navigate('/dashboard');
        setOpenKeys([]); // Fechar todos os submenus
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE', 'VENDAS/CAIXA']
    },
    {
      key: '2',
      icon: <ShoppingOutlined />,
      label: 'Produtos',
      onClick: () => {
        navigate('/produtos');
        setOpenKeys([]); // Fechar todos os submenus
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
    },
    {
      key: '3',
      icon: <AppstoreOutlined />,
      label: 'Categorias',
      onClick: () => {
        navigate('/categorias');
        setOpenKeys([]); // Fechar todos os submenus
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
    },
    {
      key: '4',
      icon: <TableOutlined />,
      label: 'Mesas',
      onClick: () => {
        navigate('/mesas');
        setOpenKeys([]); // Fechar todos os submenus
      },
      profiles: ['ADMINISTRADOR', 'GESTOR DE ESTOQUE']
    },
     
  ];

  // Filtrar menu items baseado no perfil
  const menuItems = allMenuItems.filter(item => 
    item.profiles.includes(perfil)
  );

  const onOpenChange = (keys) => {
    // Se não há keys, fecha todos os submenus
    if (keys.length === 0) {
      setOpenKeys([]);
      return;
    }
    
    // Pega a última key aberta
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    
    // Se não há uma nova key sendo aberta, fecha todos
    if (!latestOpenKey) {
      setOpenKeys([]);
      return;
    }
    
    // Se a nova key é um submenu, abre apenas esse submenu
    if (allMenuItems.find(item => item.key === latestOpenKey && item.children)) {
      setOpenKeys([latestOpenKey]);
    } else {
      setOpenKeys([]);
    }
  };

  return (
    <Layout className="restaurant-layout" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, rgba(249,130,68, 0.05) 0%, rgba(247,72,115, 0.05) 100%)'
    }}>
      <Sider 
        trigger={null} 
        collapsible 
        collapsed={collapsed}
        width={280}
        style={{
          background: 'linear-gradient(180deg, rgba(249,130,68, 0.9) 0%, rgba(247,72,115, 0.9) 100%)',
          boxShadow: '0 0 30px rgba(0,0,0,0.1)',
          position: 'fixed',
          height: '100vh',
          zIndex: 100,
        }}
      >
        {/* Logo */}
        <div style={{ 
          padding: collapsed ? '16px 0' : '24px', 
          textAlign: 'center',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          {!collapsed ? (
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              padding: '10px 0'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 44,
                height: 44,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.2)',
                marginRight: 12,
                backdropFilter: 'blur(5px)',
                border: '1px solid rgba(255, 255, 255, 0.3)'
              }}>
                <FaUtensils style={{ 
                  fontSize: 20, 
                  color: "white" 
                }} />
              </div>
              <Text strong style={{ 
                fontSize: 20, 
                color: 'white',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)'
              }}>
                QR ORDER
              </Text>
            </div>
          ) : (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 44,
              height: 44,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.2)',
              margin: '0 auto',
              backdropFilter: 'blur(5px)',
              border: '1px solid rgba(255, 255, 255, 0.3)'
            }}>
              <FaUtensils style={{ 
                fontSize: 20, 
                color: "white" 
              }} />
            </div>
          )}
        </div>

        {/* Menu Principal */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={selectedKey}
          openKeys={openKeys}
          onOpenChange={onOpenChange}
          style={{
            background: 'transparent',
            borderRight: 0,
            marginTop: 24,
            padding: '0 12px'
          }}
          items={menuItems.map(item => {
            if (item.children) {
              // Submenu com children
              return {
                ...item,
                label: (
                  <span style={{
                    fontWeight: 500,
                    fontSize: 15,
                    color: openKeys.includes(item.key) || selectedKey.some(key => key.startsWith(item.key + '-')) ? 'white' : 'rgba(255,255,255,0.85)'
                  }}>
                    {item.label}
                  </span>
                ),
                style: {
                  borderRadius: 8,
                  marginBottom: 8,
                  background: openKeys.includes(item.key) || selectedKey.some(key => key.startsWith(item.key + '-')) ? 'rgba(255,255,255,0.15)' : 'transparent',
                  transition: 'all 0.2s'
                },
                children: item.children.map(child => ({
                  ...child,
                  label: (
                    <span style={{
                      fontWeight: 400,
                      fontSize: 14,
                      color: selectedKey.includes(child.key) ? 'white' : 'rgba(255,255,255,0.85)'
                    }}>
                      {child.label}
                    </span>
                  ),
                  style: {
                    borderRadius: 6,
                    marginBottom: 4,
                    background: selectedKey.includes(child.key) ? 'rgba(255,255,255,0.15)' : 'transparent',
                    transition: 'all 0.2s'
                  }
                }))
              };
            } else {
              // Item simples
              return {
                ...item,
                label: (
                  <span style={{
                    fontWeight: 500,
                    fontSize: 15,
                    color: selectedKey.includes(item.key) ? 'white' : 'rgba(255,255,255,0.85)'
                  }}>
                    {item.label}
                  </span>
                ),
                style: {
                  borderRadius: 8,
                  marginBottom: 8,
                  background: selectedKey.includes(item.key) ? 'rgba(255,255,255,0.15)' : 'transparent',
                  transition: 'all 0.2s'
                }
              };
            }
          })}
        />

        {/* Perfil do Usuário */}
        <div style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          padding: '16px',
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          background: 'rgba(0,0,0,0.1)',
          backdropFilter: 'blur(5px)'
        }}>
          <Dropdown menu={{ items: userMenuItems }} placement="topRight">
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              padding: '8px 12px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              ':hover': {
                background: 'rgba(255,255,255,0.1)'
              }
            }}>
              {!collapsed && (
                <div style={{ marginLeft: '12px' }}>
                  <Text strong style={{ 
                    display: 'block', 
                    color: 'white',
                    fontSize: 14
                  }}>
                    {nome}
                  </Text>
                  <Text style={{ 
                    color: 'rgba(255,255,255,0.7)', 
                    fontSize: 12 
                  }}>
                    {perfil}
                  </Text>
                </div>
              )}
            </div>
          </Dropdown>
        </div>
      </Sider>

      {/* Área de Conteúdo */}
      <Layout style={{ 
        marginLeft: collapsed ? 80 : 280, 
        transition: 'all 0.3s cubic-bezier(0.2, 0, 0, 1)',
        background: 'transparent'
      }}>
        <Header
          style={{
            padding: 0,
            background: 'rgba(255,255,255,0.8)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 1px 10px rgba(0,0,0,0.05)',
            position: 'sticky',
            top: 0,
            zIndex: 10,
            borderBottom: '1px solid rgba(0, 0, 0, 0.05)'
          }}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{
              fontSize: '18px',
              width: 64,
              height: 64,
              color: 'rgba(247,72,115, 0.9)'
            }}
          />
        </Header>

        <Content
          style={{
            margin: '24px 16px',
            padding: 24,
            minHeight: 280,
            background: 'rgba(255,255,255,0.8)',
            backdropFilter: 'blur(8px)',
            borderRadius: 12,
            boxShadow: '0 1px 10px rgba(0,0,0,0.03)'
          }}
        >
          <Outlet />
        </Content>
      </Layout>

      {/* Estilos CSS para o submenu */}
      <style jsx global>{`
        /* Menu principal */
        .ant-menu {
          background: transparent !important;
        }

        /* Submenu inline (dentro do Sider) */
        .ant-menu-sub.ant-menu-inline {
          background: linear-gradient(180deg, rgba(249,130,68, 0.95) 0%, rgba(247,72,115, 0.95) 100%) !important;
          border-radius: 8px !important;
          margin: 4px 0 !important;
          padding: 6px !important;
          border: none !important;
        }

        /* Itens do submenu inline */
        .ant-menu-sub.ant-menu-inline .ant-menu-item {
          border-radius: 6px !important;
          margin: 4px 0 !important;
          color: rgba(255,255,255,0.85) !important;
          font-weight: 500 !important;
          font-size: 14px !important;
          background: transparent !important;
          transition: all 0.2s ease !important;
        }

        .ant-menu-sub.ant-menu-inline .ant-menu-item:hover {
          background: rgba(255,255,255,0.15) !important;
        }

        .ant-menu-sub.ant-menu-inline .ant-menu-item-selected {
          background: rgba(255,255,255,0.25) !important;
          color: white !important;
        }

        /* Corrigir ícones e setinhas */
        .ant-menu-submenu-title, 
        .ant-menu-submenu-arrow {
          color: rgba(255,255,255,0.9) !important;
        }

        .ant-menu-submenu-title:hover {
          background: rgba(255,255,255,0.1) !important;
        }

        /* Setas do submenu */
        .ant-menu-submenu-arrow::before,
        .ant-menu-submenu-arrow::after {
          background-color: rgba(255,255,255,0.85) !important;
        }
      `}</style>
    </Layout>
  );
};

export default Home;